import React from 'react';
import { t } from 'Src/i18n';
import { Badge } from 'Components/frameworks/badge/Badge';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
type AdditionalTransportComplexFlightsProps = {
  proposalId: string;
};
export const AdditionalTransportComplexFlights = ({
  proposalId,
}: AdditionalTransportComplexFlightsProps) => {
  const phoneNumber = t('travelAdvisor.phoneNumber');
  // One space is because phone number can not be empty
  const hasPhoneNumber = phoneNumber && phoneNumber !== ' ';
  return (
    <div
      data-testid="AdditionalTransportComplexFlights"
      className="h-full rounded-12 border-1 border-lightGrey bg-white p-20"
    >
      <div className="flex items-start gap-20">
        <Badge
          className="size-48 border-lightSand bg-lightSand text-black"
          iconName={ICONS.TAKE_OFF}
        />
        <div className="text-start text-16">
          <p className="font-semibold leading-normal">{t('booking.transport.trip.title')}</p>
          <p className="mt-8 leading-normal">{t('booking.transport.trip.information')}</p>
          <div className="flex items-center leading-normal">
            <p>{t('booking.transport.trip.referenceNumberInformation')}</p>
            &nbsp;
            <p className="font-semibold">{proposalId}</p>
          </div>
          {hasPhoneNumber && (
            <a href={`tel:${phoneNumber}`} className="mt-8 flex w-fit cursor-pointer items-center">
              <Icon name={ICONS.PHONE} width="24px" />
              &nbsp;
              <p className="font-semibold">{phoneNumber}</p>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
